import React, { FC } from "react";

import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';

import SCLogo from "../assets/icons/logo-text-color.svg";

type NavProps = {};

export const Nav: FC<NavProps> = () => {
    return (
        <>
            <Navbar bg="light" variant="light">
                <Container>
                    <Navbar.Brand href="https://sourcecoders.io">
                        <img
                        alt=""
                        src={ SCLogo }
                        height="50"
                        className="d-inline-block align-top"
                        />{' '}
                    </Navbar.Brand>
                </Container>
            </Navbar>
        </>
    );
}